import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d2f0df08&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d2f0df08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f0df08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f0df08')) {
      api.createRecord('d2f0df08', component.options)
    } else {
      api.reload('d2f0df08', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d2f0df08&scoped=true&", function () {
      api.rerender('d2f0df08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZQJs7ffVeZEG/JS/comp/PopupBox.vue"
export default component.exports